const filterOperators = new Map();
filterOperators.set("LESS_THAN", {
    displayName: "less than",
    name: "LESS_THAN",
    value: 0,
});
filterOperators.set("LESS_THAN_OR_EQUAL", {
    displayName: "less than or equal to",
    name: "LESS_THAN_OR_EQUAL",
    value: 1,
});
filterOperators.set("BEFORE", {
    displayName: "before",
    name: "LESS_THAN",
    value: 0,
});
filterOperators.set("GREATER_THAN_OR_EQUAL", {
    displayName: "greater than or equal to",
    name: "GREATER_THAN_OR_EQUAL",
    value: 2,
});
filterOperators.set("GREATER_THAN", {
    displayName: "greater than",
    name: "GREATER_THAN",
    value: 3,
});
filterOperators.set("AFTER", {
    displayName: "after",
    name: "GREATER_THAN",
    value: 3,
});
filterOperators.set("EQUAL", {
    displayName: "equals",
    name: "EQUAL",
    value: 4,
});
filterOperators.set("IN", {
    displayName: "is one of",
    name: "IN",
    value: 5,
});
filterOperators.set("ILIKE", {
    displayName: "contains",
    name: "ILIKE",
    value: 6,
});
filterOperators.set("LIKE", {
    displayName: "like (case sensitive)",
    name: "LIKE",
    value: 7,
});
filterOperators.set("NOT_IN", {
    displayName: "is not one of",
    name: "NOT_IN",
    value: 8,
});
filterOperators.set("NOT_ILIKE", {
    displayName: "doesn't contain",
    name: "NOT_ILIKE",
    value: 9,
});
filterOperators.set("NOT_EQUAL", {
    displayName: "not equal to",
    name: "NOT_EQUAL",
    value: 10,
});
filterOperators.set("EMPTY", {
    displayName: "is empty",
    name: "EMPTY",
    value: 11,
});
filterOperators.set("NOT_EMPTY", {
    displayName: "is not empty",
    name: "NOT_EMPTY",
    value: 12,
});
filterOperators.set("LAST_YEAR", {
    displayName: "last year",
    name: "LAST_YEAR",
    value: 13,
});
filterOperators.set("LAST_QUARTER", {
    displayName: "last quarter",
    name: "LAST_QUARTER",
    value: 14,
});
filterOperators.set("LAST_MONTH", {
    displayName: "last month",
    name: "LAST_MONTH",
    value: 15,
});
filterOperators.set("LAST_WEEK", {
    displayName: "last week",
    name: "LAST_WEEK",
    value: 16,
});
filterOperators.set("YESTERDAY", {
    displayName: "yesterday",
    name: "YESTERDAY",
    value: 17,
});
filterOperators.set("TODAY", {
    displayName: "today",
    name: "TODAY",
    value: 18,
});
filterOperators.set("THIS_WEEK", {
    displayName: "this week",
    name: "THIS_WEEK",
    value: 19,
});
filterOperators.set("THIS_MONTH", {
    displayName: "this month",
    name: "THIS_MONTH",
    value: 20,
});
filterOperators.set("THIS_QUARTER", {
    displayName: "this quarter",
    name: "THIS_QUARTER",
    value: 21,
});
filterOperators.set("THIS_YEAR", {
    displayName: "this year",
    name: "THIS_YEAR",
    value: 22,
});
filterOperators.set("TOMORROW", {
    displayName: "tomorrow",
    name: "TOMORROW",
    value: 23,
});
filterOperators.set("NEXT_WEEK", {
    displayName: "next week",
    name: "NEXT_WEEK",
    value: 24,
});
filterOperators.set("NEXT_MONTH", {
    displayName: "next month",
    name: "NEXT_MONTH",
    value: 25,
});
filterOperators.set("NEXT_QUARTER", {
    displayName: "next quarter",
    name: "NEXT_QUARTER",
    value: 26,
});
filterOperators.set("NEXT_YEAR", {
    displayName: "next year",
    name: "NEXT_YEAR",
    value: 27,
});
filterOperators.set("ALL", {
    displayName: "is all of",
    name: "ALL",
    value: 28,
});
filterOperators.set("NOT_ALL", {
    displayName: "is not all of",
    name: "NOT_ALL",
    value: 29,
});
const isArgumentlessOperator = (operatorName) => {
    return (operatorName === "EMPTY" ||
        operatorName === "NOT_EMPTY" ||
        operatorName === "LAST_YEAR" ||
        operatorName === "LAST_QUARTER" ||
        operatorName === "LAST_MONTH" ||
        operatorName === "LAST_WEEK" ||
        operatorName === "YESTERDAY" ||
        operatorName === "TODAY" ||
        operatorName === "THIS_WEEK" ||
        operatorName === "THIS_MONTH" ||
        operatorName === "THIS_QUARTER" ||
        operatorName === "THIS_YEAR" ||
        operatorName === "TOMORROW" ||
        operatorName === "NEXT_WEEK" ||
        operatorName === "NEXT_MONTH" ||
        operatorName === "NEXT_QUARTER" ||
        operatorName === "NEXT_YEAR");
};
export { filterOperators, isArgumentlessOperator };
